import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import Modal from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import { MissionTrackingReminder } from '../../../lib/types/models/staff/staff-reminder'
import {
  getMissionTrackingReminderSenderLabel,
  getStaffReminderLabel,
  getStaffReminderTypeLabel,
  getStaffReminderVariant
} from '../../../lib/utils/functions/staff-reminder.functions'

const HISTORY_HEADERS = ['N°', 'Date', 'Type', 'Envoyée par']

/**
 * Shows only the latest AAT reminder; clicking it opens the full history
 * (number, date, type and sender).
 */
const MissionTrackingRemindersCell = ({
  title,
  reminders
}: {
  title: string
  reminders?: MissionTrackingReminder[]
}) => {
  const { modalState, toggleModal, closeModel } = useModalManager<'reminders-history'>([
    'reminders-history'
  ])

  if (!reminders || reminders.length === 0) return '-'

  const latestReminder = reminders[reminders.length - 1]

  return (
    <div className="py-2">
      <Badge
        variant={getStaffReminderVariant(latestReminder)}
        text={getStaffReminderLabel(latestReminder)}
        onClick={() => toggleModal('reminders-history')}
      />
      {/* the popup is portaled but its clicks still bubble to the row, which opens the tracking */}
      <div onClick={(event) => event.stopPropagation()}>
        <Modal
          hideActions
          title={title}
          size="medium"
          isOpen={modalState['reminders-history']}
          onCancel={() => closeModel('reminders-history')}
        >
          <table className="w-full text-left">
            <thead>
              <tr>
                {HISTORY_HEADERS.map((header) => (
                  <th key={header} className="py-2 pr-4">
                    <Typography variant="label-semibold">{header}</Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reminders.map((reminder) => (
                <tr key={reminder.index}>
                  <td className="py-2 pr-4">
                    <Badge
                      variant={getStaffReminderVariant(reminder)}
                      text={`R${reminder.index}`}
                    />
                  </td>
                  <td className="py-2 pr-4">
                    <Typography variant="text">
                      {DateFormatter.DDMMYYYY(reminder.sentAt)}
                    </Typography>
                  </td>
                  <td className="py-2 pr-4">
                    <Typography variant="text">{getStaffReminderTypeLabel(reminder)}</Typography>
                  </td>
                  <td className="py-2 pr-4">
                    <Typography variant="text">
                      {getMissionTrackingReminderSenderLabel(reminder)}
                    </Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      </div>
    </div>
  )
}

export default MissionTrackingRemindersCell
